import React from 'react';

import {AutosuggestItem} from '@pb/kit-component-autosuggest-v2';
import {Group} from '@pb/kit-component-group';
import Loading from '@pb/kit-component-loading';

import type {AccountGroup} from 'src/openapi/admin/models/AccountGroup';
import type {ServerResponse} from 'src/typedef';

type Props = {
    id: string,
    busy: boolean,
    response: ServerResponse<Array<AccountGroup>> | null,
};

export const GroupsList = ({id, busy, response}: Props) => {
    if (busy) {
        return (
            <div id={id} className="pd-s">
                <Group><Loading type="ICON"/> Loading</Group>
            </div>
        );
    }

    if (response?.data?.length) {
        return (
            <div id={id}>
                {response.data.map(group => (
                    <AutosuggestItem
                        key={group.id}
                        value={group}
                        caption={group.name}
                    />
                ))}
            </div>
        );
    }

    if (response?.data && !response.data.length) {
        return (
            <div id={id} className="pd-s">
                No groups found
            </div>
        );
    }

    if (response?.error) {
        return (
            <div id={id} className="pd-s">
                {response.error.message}
            </div>
        );
    }

    return null;
};
